<template>
  <v-container>

    <v-container>
        <v-form>
          <v-card shaped>
            <v-card-title>Fax Number</v-card-title>
            <v-card-subtitle>Enter the faxhound fax number to drop a PDF to. Faxhound fax lines have to have PDF drop enabled in order to use this service.</v-card-subtitle>
            <v-card-text>
            <v-text-field
              v-model="faxNumber"
              label="Fax number"
              v-mask="faxMask" 
            ></v-text-field>
            </v-card-text>
            <v-card-actions>
            <v-btn
              color="success"
              v-on:click="gotoUpload"
            >Send
            </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
        <v-dialog v-model="showBadFax" persistent max-width="350">
            <v-card>
              <v-card-title class="headline">Error</v-card-title>
              <v-card-text>Fax line does not exist or is not enabled for PDF drop.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" text v-on:click="showBadFax = false">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    </v-container>
  </v-container>
</template>

<script>

  import gql from 'graphql-tag';
  import {mask} from 'vue-the-mask';

  
  const getFaxQry = gql`
    query faxPublicQry($number: String) {
      faxPublic(number: $number) {
        number
        requires_password
      }
    }
  `;

  export default {
    name: 'PDFDrop',
    props: {

    },
    directives: {
      mask
    },
    data: () => ({
      faxNumber: null,
      faxMask: '1-(###)-###-####',
      showBadFax: false,
    }),
    methods: {
      getFax: function() {
        let self = this;
        return new Promise(function(resolve,reject) {    
          let variables = {
            number:  self.faxNumber.replace(/^1/,'').replace(/\-/g,'',).replace(/\(/g,'').replace(/\)/,''),
          };
          self.$global.apolloClient.query({query: getFaxQry, variables, fetchPolicy: 'network-only'})
          .then( function(result) {
            if (result.data.faxPublic) {
              self.fax = result.data.faxPublic;

            }
            return resolve(self.fax);
          });
        });     
      },
      gotoUpload: function() {
        let self = this;
        this.getFax().then(function() {
          if (self.fax) {
            self.$router.push('/' +  self.fax.number);
          } else {
            self.showBadFax = true;
          }
        })
        
      },
      goHome: function() {
        this.$router.push('/');
      },
    },
    beforeMount() {
    },
    watch: {

    },
    filters: {

    },
  }
</script>
